export const partials = {
    MARKETING: {
        ELIGIBILITY_26_YEAR_OLD: '/partials/fai/post-elig-bts-26',
        ELIGIBILITY_FTTH: '/partials/fai/post-elig-emerch-ftth',
        ELIGIBILITY_PACK: '/partials/fai/offres-pack',
        FAI_ANIMCO: '/partials/fai/animcocarte',
        FAI_BOTTOM_CONTENT: '/partials/mobiles/sas/contenu',
        FAI_COMMITMENTS: '/partials/fai/engagements',
        FAI_CONTENT: '/partials/fai/contenu',
        FAI_HOME_SLIDER: '/partials/banners/Home-fai_slider',
        FAI_PACK: '/partials/fai/animco-pack',
        FAI_WIFI: '/partials/fai/wifi-num-1',
        OFFER_WALL_SLIDER: '/partials/banners/Home-mobile_slider',
        PACK_TABLET: '/partials/ec/zone_panier_bbox_tablette',
        PLAN_EUROPE: '/partials/mobiles/banniere_forfaits-mobiles_destinations_europe',
        PLAN_INTERNATIONAL: '/partials/mobiles/banniere_forfaits-mobiles_destinations',
        PROMO_INFOGRAPHIE: '/partials/mixte/infographie-top',
        PROMO_PRESENTATION: '/partials/mixte/presentation-top',
        PROMO_STORYTELLING: '/partials/mixte/presentation-storytelling',
    },
    FAQ: {
        ACCESSORY_PRODUCT: '/partials/faq/emplacements/accessoires_produit',
        BIG_HOME: '/partials/faq/emplacements/offres-box-forfait',
        FAI_HOME: '/partials/faq/emplacements/offres-internet',
        PACK_GAMING: '/partials/faq/emplacements/offres-internet_bbox-gaming',
        PACK_GAMING_PS5: '/partials/faq/emplacements/offres-internet_bbox-gaming-ps5',
        PACK_SMART_TV: '/partials/faq/emplacements/offres-internet_bbox-smart-tv',
        PACK_TABLET: '/partials/faq/emplacements/offres-internet_bbox-tablette',
        PHONE_PRODUCT: '/partials/faq/emplacements/telephones-mobiles_produit',
        WALL: '/partials/faq/emplacements/telephones-mobiles',
        WALL_RENEWAL: '/partials/faq/emplacements/forfaits-mobiles_avec-engagement-24-mois_renouvellement',
    },
    LEGALS: (url: string) => `/partials/mentions_legales/emplacements/${url}`,
    HEADER: {
        ACQ: '/partials/v3/header/index/needsupport',
        RNW: '/partials/v3/header/primary',
        LIGHT: '/partials/v3/header/light/needsupport',
    },
    FOOTER: {
        ACQ: '/partials/v3/footer',
        LIGHT: '/partials/v3/footer/light',
    },
};
